import { fetchDroneDatabasesList, fetchDashboardDatabasesList, ProjectDatabaseType, dronePlatforms } from '../../../database-list.ts';

export type DroneDatabaseKeyType = ProjectDatabaseType['dronePlatforms'][number];
export type DashboardDatabaseKeyType = ProjectDatabaseType['dashboard'][number];

export { fetchDroneDatabasesList, dronePlatforms, fetchDashboardDatabasesList };
